export default __webpack_public_path__ + "static/media/Expansion.466b7c09.png";